
export type AcnComponentValue = string | null;
